import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export function getNewsList(_x) {
  return _getNewsList.apply(this, arguments);
}
function _getNewsList() {
  _getNewsList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", usePost('/web/newsList', params));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getNewsList.apply(this, arguments);
}
export function getNewsDetail(_x2) {
  return _getNewsDetail.apply(this, arguments);
}
function _getNewsDetail() {
  _getNewsDetail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet("/web/findNewsById/".concat(id)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getNewsDetail.apply(this, arguments);
}
export function getCarouselList() {
  return _getCarouselList.apply(this, arguments);
}
function _getCarouselList() {
  _getCarouselList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", useGet('/web/carouselList'));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getCarouselList.apply(this, arguments);
}
export function getCooperateList() {
  return _getCooperateList.apply(this, arguments);
}
function _getCooperateList() {
  _getCooperateList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", useGet('/web/cooperateList'));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getCooperateList.apply(this, arguments);
}
export function getCawListApi(_x3) {
  return _getCawListApi.apply(this, arguments);
}
function _getCawListApi() {
  _getCawListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", usePost('/web/cawPage', params));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getCawListApi.apply(this, arguments);
}